//changed due to package upgrade
import React, { useEffect, useState } from 'react';
import { Container, Grid } from '@mui/material';
import jwtAxios from '@projectK/services/auth/JWT';
import TilledPaymentForm from './TilledPaymentForm';
import OrderSummary from './OrderSummary';
import { useParams } from 'react-router-dom';
import { getSavedProgress, getAuthenticatedProgressUserId } from './handleState';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import PropTypes from 'prop-types';

const Payment = ({ wizardSettings }) => {
  const { tournamentSlug } = useParams();
  const { user } = useAuthUser();

  const savedProgress = getSavedProgress(
    tournamentSlug,
    getAuthenticatedProgressUserId(user),
  );

  const CartItemData = savedProgress?.data?.payment;
  const userDetails = savedProgress?.data?.signUp;
  const [userInfo, setUserInfo] = useState(null);
  const selectedAddress = {
    address: userDetails?.address ?? userInfo?.address,
    city: userDetails?.city ?? userInfo?.city,
    state: userDetails?.state ?? userInfo?.state,
    zip_code: userDetails?.zip_code ?? userInfo?.zip_code,
    country: userDetails?.country ?? userInfo?.country,
  };
  const userData = {
    user_id: savedProgress?.data?.userId ?? user?.id,
    first_name: userDetails?.first_name ?? userInfo?.first_name,
    last_name: userDetails?.last_name ?? userInfo?.last_name,
  };
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [fee, setFee] = useState(null);

  useEffect(() => {
    fetchPaymentsData();
    fetchFeeSettings();
  }, [user?.id]);
  useEffect(() => {
    fetchUserSettings();
  }, [user?.id]);
  const fetchPaymentsData = async () => {
    try {
      const response = await jwtAxios.get(
        `/customer-payment`,
      );
      const { data } = response;
      setPaymentMethod(data.list);
    } catch (error) {
      setPaymentMethod(null);
    }
  };
  const fetchFeeSettings = async () => {
    try {
      const response = await jwtAxios.get(
        user?.id ? `/app-settings/` : `/public/app-settings`,
      );
      setFee(response?.data?.convenience_fee?.percentage_per_transaction);
    } catch (error) {
      console.error('Error fetching address:', error);
    }
  };
  const fetchUserSettings = async () => {
    try {
      const response = user?.id && (await jwtAxios.get(`/users/${user?.id}`));
      setUserInfo(response?.data || null);
    } catch (error) {
      console.error('Error fetching user :', error);
    }
  };
  return (
    <Container sx={{ mt: { xs: 4, sm: 8 } }}>
      <Grid container spacing={{ xs: 2, md: 5 }} className='stats'>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          {paymentMethod && (
            <TilledPaymentForm
              cartItems={CartItemData}
              discount={null}
              fee={fee}
              selectedAddress={selectedAddress}
              storePromo={null}
              paymentMethod={paymentMethod}
              promoDiscountValue={null}
              promoDiscountType={null}
              userData={userData}
              wizardSettings={wizardSettings}
            />
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default Payment;

Payment.propTypes = {
  wizardSettings: PropTypes.object,
};
